namespace RioERP.Masters {
    export interface HsnMasterRow {
        Id?: number;
        Name?: string;
        HsnCode?: string;
        TaxCategoryId?: number;
        IsActive?: boolean;
        TaxCategoryName?: string;
        TaxCategoryIsActive?: boolean;
        TaxCategoryInsertUserId?: number;
        TaxCategoryInsertDate?: string;
        TaxCategoryUpdateUserId?: number;
        TaxCategoryUpdateDate?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace HsnMasterRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Masters.HsnMaster';
        export const lookupKey = 'Masters.HSNMaster';

        export function getLookup(): Q.Lookup<HsnMasterRow> {
            return Q.getLookup<HsnMasterRow>('Masters.HSNMaster');
        }
        export const deletePermission = 'Masters:MastersManagement:Modify';
        export const insertPermission = 'Masters:MastersManagement:Modify';
        export const readPermission = 'Masters:MastersManagement:View';
        export const updatePermission = 'Masters:MastersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            HsnCode = "HsnCode",
            TaxCategoryId = "TaxCategoryId",
            IsActive = "IsActive",
            TaxCategoryName = "TaxCategoryName",
            TaxCategoryIsActive = "TaxCategoryIsActive",
            TaxCategoryInsertUserId = "TaxCategoryInsertUserId",
            TaxCategoryInsertDate = "TaxCategoryInsertDate",
            TaxCategoryUpdateUserId = "TaxCategoryUpdateUserId",
            TaxCategoryUpdateDate = "TaxCategoryUpdateDate",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
